// src/components/admin/nornsweave/modals/DeclineModal.js
import React, { useState } from 'react';

function DeclineModal({ booking, onClose, onDecline }) {
  const [reason, setReason] = useState('');
  const [alternatives, setAlternatives] = useState('');

  const handleDecline = () => {
    onDecline(booking, reason, alternatives);
  };

  if (!booking) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
        <h3 className="text-xl font-bold text-slate-800 mb-4">Decline Booking</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Reason (optional)</label>
            <textarea
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              rows="3"
              placeholder="Why is this booking being declined?"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-slate-700 text-sm font-medium mb-1">Suggested Alternatives (optional)</label>
            <textarea
              className="w-full px-3 py-2 border border-slate-300 rounded-lg"
              rows="2"
              placeholder="e.g., Monday 10:00 AM or Tuesday 2:00 PM are available"
              value={alternatives}
              onChange={(e) => setAlternatives(e.target.value)}
            />
          </div>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-200 text-slate-700 py-2 rounded-lg hover:bg-slate-300"
            >
              Cancel
            </button>
            <button
              onClick={handleDecline}
              className="flex-1 bg-red-600 text-white py-2 rounded-lg hover:bg-red-700"
            >
              Decline Booking
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeclineModal;
